import React from 'react'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'

import { Drawer } from '@material-ui/core'
import IconButton from '@material-ui/core/IconButton'
import CloseIcon from '@material-ui/icons/Close'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import Typography from '@material-ui/core/Typography'

import { makeStyles, useTheme } from '@material-ui/core'
import { styles } from './helpPanel.styles'

import { toggleSideHelp, RootStoreModel, toggleSideChangelog } from '../../../../../../redux'
import { HelpIndex } from './helpIndex'
import { HelpContent } from './helpContent'
import { fetchHelpIndexForSection, getCurrentPageTitle } from './helpPanel.service'
import { WikiIndexEntryVM } from '../../sidePanel.model'

type HelpPanelProps = {
  onHandleClose: () => void
}

export const HelpPanel: React.FC<HelpPanelProps> = ({ onHandleClose }) => {
  const currentTheme = useTheme()
  const useStyles = makeStyles(styles(currentTheme))
  const classes = useStyles()

  const [t] = useTranslation(['help'])

  const currentSection: string = useSelector((state: RootStoreModel) => {
    return state.router && state.router.location && state.router.location.pathname
  })

  const [currentPage, setCurrentPage] = React.useState<string>('')
  const [sectionIndex, setSectionIndex] = React.useState<WikiIndexEntryVM[] | undefined>(undefined)
  const [selectedContent, setSelectedContent] = React.useState<string | undefined>(undefined)
  const [cardSubheader, setCardsubheader] = React.useState<string>(getCurrentPageTitle(currentPage))

  React.useEffect(() => {
    const getIndexForSection = async (section: string) => {
      const indexForCurrentSection: WikiIndexEntryVM[] = await fetchHelpIndexForSection(section)
      setSectionIndex(indexForCurrentSection)
    }

    const currentSectionPath = t(`help:sideHelpRoutes.${currentSection}`)
    setCurrentPage(currentSectionPath)
    setCardsubheader(getCurrentPageTitle(currentSectionPath))

    getIndexForSection(currentSectionPath)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentSection])

  const handleGoBack = React.useCallback(
    (event: React.MouseEvent<HTMLElement>) => {
      setSelectedContent(undefined)
      setCardsubheader(getCurrentPageTitle(currentPage))
    },
    [currentPage]
  )

  const handleCloseDrawer = React.useCallback((event: React.MouseEvent<HTMLElement>) => {
    setSectionIndex(undefined)
    setSelectedContent(undefined)
    onHandleClose()
  }, [])

  const handleIndexEntryClick = React.useCallback((entry: WikiIndexEntryVM) => {
    setSelectedContent(entry.path)
    setCardsubheader(entry.title)
  }, [])

  return (
    <>
      <div className={classes.cardHeader}>
        <div className={classes.cardHeaderTitleContainer}>
          <div>
            <Typography variant="h1" component="h1">
              {t('help:title')}
            </Typography>
          </div>
          <div>{cardSubheader}</div>
        </div>
        <div>
          {selectedContent ? (
            <IconButton aria-label="close" onClick={handleGoBack}>
              <ArrowBackIcon />
            </IconButton>
          ) : (
            <IconButton aria-label="close" onClick={handleCloseDrawer}>
              <CloseIcon />
            </IconButton>
          )}
        </div>
      </div>
      <div className={classes.cardContent}>
        {selectedContent ? (
          <HelpContent contentPath={selectedContent} />
        ) : (
          <HelpIndex index={sectionIndex} onClickIndexEntry={handleIndexEntryClick} />
        )}
      </div>

      {/* // Hide open in new tab action until redirection is fixed
           {selectedContent && (
            <div className={classes.cardActions}>
              <Link
                target="_blank"
                to={`/help/${encodeURIComponent(selectedContent)}`}
                className={classes.openInNewTabActionLink}
              >
                <Button size="small" color="primary">
                  {t('help:openInNewTabAction')}
                </Button>
              </Link>
            </div>
          )} */}
    </>
  )
}
